import useStarterEnabled from '~pricing/hooks/useStarterEnabled';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';

import { getPackageSetBasedOnPath } from '~pricing/lib/lib-helpers';
import { PackageSet, PackageType } from '~shared/types/pricing/package';
import { GROW_2792_PACKAGES } from '../lib/constants';

export default function usePackageSet(canonicalPath: string): { packageSet: PackageSet } {
  const { isStarterEnabled } = useStarterEnabled();
  const { uiExperiment, priceExperiment } = usePricingExperiments();

  // GROW-2529 Forms, GROW-2629 v2 Forms, price_test with major UI changes
  const isForms =
    uiExperiment.hasAssignment &&
    [
      EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment,
      EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1,
      EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2,
    ].includes(uiExperiment.treatmentName)
      ? uiExperiment
      : null;
  // END GROW-2529, GROW-2629

  // GROW-2792 PnP Refresh
  const isPnPRefresh =
    canonicalPath !== PackageType.Educational &&
    priceExperiment.hasAssignment &&
    priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment;

  function determinePackageSet(): PackageSet {
    return isPnPRefresh ? GROW_2792_PACKAGES : getPackageSetBasedOnPath(canonicalPath, isForms, isStarterEnabled);
  }

  return {
    packageSet: determinePackageSet(),
  };
}
